import React, {lazy, Suspense} from 'react'

const OrganizationPageLazy = lazy(() =>
    import('./OrganizationPage')
)

const OrganizationPage = props => (
    <Suspense fallback={null}>
        <OrganizationPageLazy {...props} />
    </Suspense>
)

export default OrganizationPage
